export default __webpack_public_path__ + "static/1-b0870fcb40c25cb48d1e90fc061b35a7.jpeg";